import React, { useContext } from 'react';
import { SerializedSmartLink, SerializedWidget } from 'fym-common/src/db/serializersTypes';
import { EditorUrlState } from './url/useEditorUrlState';
import type { EditorSaveTracker } from './saves/editorSaveTracker';

/** What every part of the editor shares: the page, the URL state and the page-wide actions. */
export interface SMLEditorContextValue {
  smartLink: SerializedSmartLink;
  accountId: number;
  smartLinkId: number;
  isBioLink: boolean;
  artistName: string | null;
  /** The public host in front of the slug: "laziibee.music24.link/". */
  slugPrefix: string;
  url: EditorUrlState;
  /** The block under the pointer, in the panel or in the preview. */
  hoveredUUID: string | null;
  setHovered: (widgetUUID: string | null) => void;
  /** Delete with Undo (or the question first for an open pre-save with fans). */
  requestDelete: (widget: SerializedWidget) => void;
  /** Shows a short notice in the editor toast. */
  showNotice: (message: string) => void;
  /** Below 992 px: forms open as a sheet, the bottom bar holds Preview and Publish. */
  isCompact: boolean;
  /** Every save of the draft: Publish waits for the saves that wait or run. */
  saves: EditorSaveTracker;
}

export const SMLEditorContext = React.createContext<SMLEditorContextValue | null>(null);

export function useEditorContext(): SMLEditorContextValue {
  const value = useContext(SMLEditorContext);
  if (value === null) {
    throw new Error('useEditorContext needs SMLEditorContext.Provider');
  }
  return value;
}
